import { useEffect, useState } from 'react'

import mqttClient from './request'
import type { MqttClientInstance, MqttConnectionStatus } from './types'

type UseMqttStateResult = {
  connectionStatus: MqttConnectionStatus
  client: MqttClientInstance
}

export default function useMqttState(): UseMqttStateResult {
  const [connectionStatus, setConnectionStatus] = useState<MqttConnectionStatus>(mqttClient.getConnectionStatus())
  const [client, setClient] = useState(mqttClient.getClient())

  useEffect(() => {
    const unsubscribe = mqttClient.subscribeStatus(status => {
      setConnectionStatus(status)
      setClient(mqttClient.getClient())
    })

    return unsubscribe
  }, [])

  return {
    connectionStatus,
    client
  }
}
